import { apiService } from "./apiService";

const FILES_URL = "/files";

export const getFiles = async (fileUrl: string): Promise<any> => {
  try {
    const response = await apiService.get<any>(FILES_URL, {
      params: { file_url: fileUrl },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const postFiles = async (data: PostFildsData): Promise<PostFildsResponse> => {
  try {
    const response = await apiService.post<PostFildsResponse>(FILES_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};